module.exports = __webpack_public_path__ + "fa67c989114002dff5ed3ef99a3135db.svg";